var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamilloAdvIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20_48)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 14.3674,
    y1: 6.5,
    x2: 61.4303,
    y2: 6.5,
    stroke: "#BB9469",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 1.5,
    x2: 71,
    y2: 1.5,
    stroke: "#BB9469",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.6326,
    y1: 57.5,
    x2: 13.5697,
    y2: 57.5,
    stroke: "#BB9469",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: 62.5,
    x2: 4,
    y2: 62.5,
    stroke: "#BB9469",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9263 48.576C35.8356 48.576 34.1289 48.3413 32.8063 47.872C31.4836 47.36 30.5236 46.464 29.9263 45.184C29.3289 43.8613 29.0303 41.9413 29.0303 39.424V23.808C29.0303 20.6933 29.6916 18.5813 31.0143 17.472C32.3796 16.32 34.6196 15.744 37.7343 15.744C40.7636 15.744 42.9396 16.2987 44.2623 17.408C45.6276 18.5173 46.3103 20.5653 46.3103 23.552V27.712H42.3423V23.424C42.3423 21.5893 42.0436 20.2667 41.4463 19.456C40.8489 18.6027 39.6116 18.176 37.7343 18.176C35.8569 18.176 34.5983 18.6027 33.9583 19.456C33.3183 20.2667 32.9983 21.5893 32.9983 23.424V40.448C32.9983 42.496 33.3183 43.9467 33.9583 44.8C34.5983 45.6107 35.8996 46.016 37.8623 46.016C39.6543 46.016 40.8489 45.6107 41.4463 44.8C42.0436 43.9893 42.3423 42.5387 42.3423 40.448V36.16H46.3103V39.424C46.3103 41.856 46.0116 43.7333 45.4143 45.056C44.8169 46.3787 43.8996 47.296 42.6623 47.808C41.4249 48.32 39.8463 48.576 37.9263 48.576Z",
    fill: "#BB9469"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.5,
    y1: 50,
    x2: 51.5,
    y2: 10,
    stroke: "#BB9469",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 11.5,
    x2: 30,
    y2: 11.5,
    stroke: "#BB9469",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 14,
    x2: 22.5,
    y2: 54,
    stroke: "#BB9469",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 52.5,
    x2: 44,
    y2: 52.5,
    stroke: "#BB9469",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20_48",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20_48"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20_48",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamilloAdvIcon);
export default __webpack_public_path__ + "static/media/camillo-adv-icon.2771d20bc3a210f8538555b2c55b844b.svg";
export { ForwardRef as ReactComponent };